export const CONSTANTS = {
    DEFAULT_CULTURE: 'en',
    CURRENT_CULTURE: document.documentElement.lang ?? 'en',

    CF_TURNSTILE_HTTP_HEADER: 'x-cf-turnstile-response',
}
